<ng-container>
  @for (notification of notifications; track notification) {
    <div>
      @if (notification.type !== 'recertification') {
        <pl-alert
          [@fadeOut]
          [close]="notification.isClosable"
          [color]="notification.status"
          [display]="notification.display"
          >
          <span header>{{ notification.header }}</span>
          @if (notification.type === 'revision') {
            <span content>
              Existe@if (notification?.revision?.logonsTotal! > 1) {
              <span>m</span>
              } em
              seu contrato
              <b
                >{{ notification.revision?.logonsTotal }} usuário@if (notification?.revision?.logonsTotal! > 1) {
                <span
                  >s</span
                  >
                  }</b
                  >
                  com iminência de bloqueio por falta de revisão de acesso.
                  <a class="link-notification" routerLink="/revision"
                    >Revisar acessos dos usuários.</a
                    >
                  </span>
                }
                @if (notification.type === 'distribution') {
                  <span content>
                    Você está visualizando todos os usuários vinculados ao seu CNPJ. Acesse
                    o sistema <b>Administração de Acessos</b> para gerenciar os usuários da
                    sua filial.
                    @if (notification.type === 'distribution') {
                      <a
                        class="link-notification"
                        (click)="callAccessesAdminApp()"
                        >Acessar</a
                        >
                      }
                    </span>
                  }
                  @if (
                    notification.type !== 'revision' &&
                    notification.type !== 'distribution'
                    ) {
                    <span
                      content
                      >
                      {{ notification.content }}
                    </span>
                  }
                </pl-alert>
              } @else {
                <pl-alert-recertification
                  [@fadeOut]
                  [close]="notification.isClosable"
                  [daysLeft]="notification.recertification?.remainingDays"
                  [limitDate]="notification.recertification?.limitDate"
                  [status]="notification.recertification?.status"
                  >
                </pl-alert-recertification>
              }
              <ng-template #recertification>
                <pl-alert-recertification
                  [@fadeOut]
                  [close]="notification.isClosable"
                  [daysLeft]="notification.recertification?.remainingDays"
                  [limitDate]="notification.recertification?.limitDate"
                  [status]="notification.recertification?.status"
                  >
                </pl-alert-recertification>
              </ng-template>
            </div>
          }
        </ng-container>
